/* eslint-disable no-use-before-define,eqeqeq */
import React from 'react'
import { fmt, getId } from '../../twd'

export const Table = ({context}) => {

    const n = context.filterByDate
    return <React.Fragment>
        <div className="row">
        <h4 className="col-md-6 text-medium" style={{fontSize: 'inherit'}}>
            {context.showDataAs === 'price-history' ? 'Price' : 'Yield'} history details for {n == 0 ? 'today' : `last ${n} days`}
        </h4>
        <div className="col-md-6 text-right">
            <JumpTo context={context} />
        </div>
        </div>
        <Details context={context} />

    </React.Fragment>
}

const JumpTo  = ({context,}) => {
    const id = getId()
    return <React.Fragment>
    <label htmlFor={id} className="text-medium" style={{fontSize: 'inherit', display:'inline'}}>Jump to </label>
    <div className='select-wrapper inline' style={getSelectStyle()}>
    <select
        id={id}
        aria-label={`select trade date`}
        defaultValue={context.lastTradeDate}
        style={{paddingRight:'25px'}}
        className="text-bold"
        onChange={(e) => {
            document.location.href=`#trade-history-detail-${fmt.mdy(e.target.value)}`
        }}
        >
            {context.tradeDates.map((date,i) => <option key={`trade-date-${i}`} value={date}>{date}</option>)}
        </select>
    </div>
    </React.Fragment>
}

const getSelectStyle = () => {
    const color = getComputedStyle(document.documentElement)
        .getPropertyValue('--primary-base-color')
        .trim() || '#5627d8'
    console.log(color)
    return {
        display: 'inline',
        backgroundImage: "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='12px' height='10px' viewBox='258 91 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(264.000000, 96.000000) rotate(90.000000) translate(-264.000000, -96.000000) translate(260.500000, 90.000000)'%3E%3Cpolygon id='Shape' fill='" + color.replace('#','%23') + "' points='1 0 -0.4 1.4 4.2 6 -0.4 10.6 1 12 7 6'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'calc(100% - 7px) 50%',
    }
}


const Details = ({context}) => {
    const {details, summary} = context.tradeDetails

    return <React.Fragment>
        <DetailsTable context={context} details={details} />
        <DetailsSummary context={context} {...summary} />
    </React.Fragment>
}

const DetailsTable = ({details}) => {
    return <React.Fragment>
        <div className="row table-responsive vertical-offset-xs trade-history-table-scroll"
        style={{
            margin: 0,
            background: '#ffffff',
            border: 'solid 1px #e4e4e4',
            minHeight: '360px',
            maxHeight: '360px',
            overflowY: 'auto',
        }}>
        <div className="col-md-12">
        <table className="table table-striped trade-history-sticky-table" style={{marginBottom:0}}>
        <thead>
        <tr>
            <th>Trade time</th>
            <th className="text-right">Price</th>
            <th className="text-right">Yield</th>
            <th className="text-right">Quantity</th>
            <th>Trade Type (Special Notes)</th>
        </tr>
        </thead>
        <tbody>{(() => {
            let curr = null
            return details.map((r,i) => {
                const a = curr !== r.tradeDate
                if (a) { curr = r.tradeDate }
                return <DetailRow key={`detail-${i}`} idx={i} isNewSection={a} {...r} />
            })
        })()}</tbody>
        </table>
        </div>
        </div>
    </React.Fragment>
}

const DetailRow = ({idx, tradeDateTime, tradePrice, tradeYield, tradeQuantity, tradeType, tradeNotes, isEstimate, isNewSection}) => {

    return <React.Fragment>
        <tr key={`trade-history-detail-${idx}`}
            { ...(isNewSection ? {id:`trade-history-detail-${fmt.mdy(tradeDateTime)}`} : {}) }
            style={isNewSection ? {scrollMarginTop: 'var(--trade-history-sticky-h1, 40px)'} : {}}
        >
            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>{fmt.ts(tradeDateTime)}</td>
            <td className="text-right" style={{verticalAlign:'top'}}>{fmt.price3(tradePrice)}</td>
            <td className="text-right" style={{verticalAlign:'top'}}>{fmt.ytw3(tradeYield)}</td>
            <td className="text-right" style={{verticalAlign:'top'}}>{isEstimate ? '* 1,000' : fmt.qty(tradeQuantity)}</td>
            <td style={{ verticalAlign: 'top' }}>{tradeType} {tradeNotes ? `(${tradeNotes})` : ''}</td>
        </tr>
    </React.Fragment>
}

const DetailsSummary = ({ totalTrades, averagePrice, averageYield, hasEstimates }) => {
    return <React.Fragment>
        <div className="row vertical-offset-xs">
        <div className="col-md-6">
            <div style={{minWidth:'90px', display:'inline-block'}}>
                <div>Total trades</div>
                <div className="text-medium">{fmt.qty(totalTrades)}</div>
            </div>
            <div style={{minWidth:'90px', display:'inline-block'}}>
                <div className="text-right">Average price</div>
                <div className="text-medium text-right">{fmt.price3(averagePrice)}</div>
            </div>
            <div style={{minWidth:'90px', display:'inline-block'}}>
                <div className="text-right">Average yield</div>
                <div className="text-medium text-right">{fmt.ytw3(averageYield)}</div>
            </div>
        </div>
        <div className="col-md-6 text-right text-small">
        {hasEstimates ? <React.Fragment>* Total quantity traded may be greater due to 1MM+ trades<br/></React.Fragment> : null}
        Source: FINRA TRACE/MSRB
        </div>
        </div>
    </React.Fragment>
}